// Central site content. Edit copy here rather than inside components.
// Items marked TODO need confirmation from the Fedigma team.

export const company = {
  name: 'Fedigma',
  legalName: 'Fedigma Forge Pvt Ltd',
  tagline: 'Fusion of Digital Management for Education',
  summary: 'Fedigma is the Fusion of Digital Management for the education sector: one partner for every digital need of schools, colleges, kindergartens, libraries and private institutes.',
  email: 'info@fedigmaforge.com',
  phones: [
    { display: '+91 79845 04286', href: 'tel:+917984504286' },
    { display: '+91 95993 00796', href: 'tel:+919599300796' }
  ],
  whatsapp: 'https://wa.me/917984504286',
  address: 'D 60/61 Sewak Park, Dwarka, New Delhi, India',
  mapUrl: 'https://maps.google.com/?q=D+60/61+Sewak+Park,+Dwarka,+New+Delhi,+India',
  hours: 'Mon – Sat, 10:00 AM – 7:00 PM IST', // TODO: confirm business hours
  socials: {
    linkedin: 'https://www.linkedin.com/company/fedigmaforge/',
    instagram: 'https://www.instagram.com/fedigma_',
    facebook: 'https://www.facebook.com/fedigmaforge'
  }
};

export const stats = [
  { value: '2+', label: 'Years of experience' },
  { value: '27+', label: 'Projects delivered' },
  { value: '20+', label: 'Clients served' },
  { value: '9', label: 'Services under one roof' }
];

export const institutionTypes = [
  'Schools',
  'Colleges',
  'Kindergartens',
  'Libraries',
  'Coaching & private institutes'
];

// Names shown in the "trusted by" strip on the homepage.
export const featuredClients = [
  'Advance Forte',
  'EduMerit Institute',
  'IBS Bank Career',
  '1 IAS Institute',
  'Defence Forte',
  'GAIL Officers Association',
  'ABCD Pathshala',
  'Gronikk'
];

// Full client list, grouped by the work we do for them.
export const clientGroups = [
  {
    title: 'Education websites & digital presence',
    text: 'Websites we built and whose online presence we manage.',
    clients: ['Advance Forte', 'EduMerit Institute', 'IBS Bank Career', '1 IAS Institute', 'Defence Forte']
  },
  {
    title: 'Digital presence management',
    text: 'Institutes whose social media, listings and reputation we manage.',
    clients: ['ABCD Pathshala', 'Abacus', 'Gronikk', 'Several kindergartens']
  },
  {
    title: 'Custom websites',
    text: 'Websites built for associations and businesses beyond education.',
    clients: ['GAIL Officers Association', 'GEHS', 'FoldX', 'Divelora', 'Aastha Regency', 'Mepiyu']
  }
];

export const services = [
  {
    id: 'web-development',
    icon: 'code',
    title: 'Website Development',
    description: 'Fast, mobile-friendly websites for schools, colleges and institutes.',
    outcome: 'More admission enquiries online',
    link: '/services/web-development'
  },
  {
    id: 'mobile-app',
    icon: 'smartphone',
    title: 'App Development',
    description: 'Android and iOS apps for students, parents, teachers and staff.',
    outcome: 'Your institute in every pocket',
    link: '/services/mobile-app'
  },
  {
    id: 'school-management',
    icon: 'book',
    title: 'School & Institute ERP',
    description: 'EdTrack Smart, our own ERP for schools, coaching institutes, colleges and libraries.',
    outcome: 'Hours of admin saved every week',
    link: '/services/school-management'
  },
  {
    id: 'online-presence',
    icon: 'globe',
    title: 'Digital Presence Management',
    description: 'Social media, Google listings and reviews managed month after month.',
    outcome: 'Be found and trusted by parents',
    link: '/services/online-presence'
  },
  {
    id: 'digital-marketing',
    icon: 'trending',
    title: 'Digital Marketing',
    description: 'Admission campaigns, SEO and ads measured by real enquiries.',
    outcome: 'Fuller batches every session',
    link: '/services/digital-marketing'
  },
  {
    id: 'digital-classroom',
    icon: 'monitor',
    title: 'Digital Classroom Setup',
    description: 'Smart boards, panels and classroom tech, set up through trusted vendors.',
    outcome: 'Modern classrooms without the hassle',
    link: '/services/digital-classroom'
  },
  {
    id: 'content-writing',
    icon: 'edit',
    title: 'Educational Content Writing',
    description: 'Study material, question banks, blogs, prospectus and website copy.',
    outcome: 'Clear content that teaches and sells',
    link: '/services/content-writing'
  },
  {
    id: 'career-counselling',
    icon: 'compass',
    title: 'Career Counselling',
    description: 'Guidance for students on streams, courses, colleges and careers.',
    outcome: 'Confident choices for every student',
    link: '/services/career-counselling'
  },
  {
    id: 'creative-services',
    icon: 'film',
    title: 'Video, Design & Documentation',
    description: 'Video editing, graphic design and help with institutional paperwork.',
    outcome: 'Professional output, on time',
    link: '/services/creative-services'
  }
];

export const process = [
  { title: 'Discover', text: 'A free consultation to understand your institute, goals and budget.', output: 'Clear understanding of your needs' },
  { title: 'Plan', text: 'A proposal with scope, timeline and a fixed quote for you to approve.', output: 'Fixed quote, no surprises' },
  { title: 'Build', text: 'We design, develop or set up in milestones, with previews along the way.', output: 'Progress you can see' },
  { title: 'Launch', text: 'Go-live, handover of all access, and training for your staff.', output: 'Everything live and handed over' },
  { title: 'Support', text: 'Ongoing management, updates and improvements after launch.', output: 'A partner, not a one-off vendor' }
];

// Our own products, built and run by Fedigma.
export const products = {
  edtrack: {
    name: 'EdTrack Smart',
    url: 'https://edtracksmart.com',
    domain: 'edtracksmart.com',
    image: '/images/edtrack-smart.webp',
    tagline: 'One connected ERP for schools, coaching institutes, colleges and libraries.',
    description: 'EdTrack Smart is the institute ERP we designed, built and run. It replaces spreadsheets and separate apps with one system for admissions, attendance, fees, exams and parent communication.',
    audiences: ['Schools', 'Coaching institutes', 'Colleges & universities', 'Libraries'],
    features: [
      { title: 'Student & attendance records', text: 'Enrollment, batch allocation and daily attendance with parent notifications built in.' },
      { title: 'Fee management', text: 'Auto-generated invoices, online collection and defaulter reminders.' },
      { title: 'Exams, DPPs & results', text: 'Schedule tests, publish practice problems and share results and rank lists.' },
      { title: 'Parent & staff portal', text: 'Parents see attendance, fees and results in real time.' },
      { title: 'Multi-branch management', text: 'Run several centres or campuses from one dashboard.' },
      { title: 'Reports & analytics', text: 'Attendance, fee collection and academic performance at a glance.' }
    ]
  }
};

// Portfolio cards. Screenshots are of the live sites (placeholder counters hidden).
export const caseStudies = [
  {
    title: 'EdTrack Smart',
    category: 'Education ERP · Our own product',
    summary: 'An institute ERP for admissions, attendance, fees, exams and parent communication, used by schools, coaching institutes, colleges and libraries.',
    tags: ['ERP', 'Web app', 'Multi-branch'],
    visual: 'school',
    image: '/images/edtrack-smart.webp',
    url: 'https://edtracksmart.com'
  },
  {
    title: 'Advance Forte',
    category: 'Coaching institute · Website & digital presence',
    summary: 'Website for an IIT-JEE, NEET and Foundation coaching institute with centres in Delhi, Uttar Pradesh and Bihar, plus ongoing digital presence management.',
    tags: ['Website', 'Digital presence', 'Admissions'],
    visual: 'school',
    image: '/images/work/advanceforte-in.webp',
    url: 'https://advanceforte.in'
  },
  {
    title: 'EduMerit Institute',
    category: 'Coaching institute · Website & digital presence',
    summary: 'Website with courses, mock tests, quizzes and daily current affairs for a Greater Noida institute teaching Class 2–10 and banking & SSC exams.',
    tags: ['Website', 'Mock tests', 'Digital presence'],
    visual: 'school',
    image: '/images/work/edumerits-in.webp',
    url: 'https://edumerits.in'
  },
  {
    title: 'IBS Bank Career',
    category: 'Banking career institute · Website & digital presence',
    summary: 'Website for an Institute of Banking Studies offering JAIIB, CAIIB, IIBF, bank promotion and SSC courses, with course listings, publications and callback requests.',
    tags: ['Website', 'Course catalogue', 'Digital presence'],
    visual: 'school',
    image: '/images/work/ibsbankcareer-in.webp',
    url: 'https://ibsbankcareer.in'
  },
  {
    title: 'FoldX',
    category: 'E-commerce · Custom website',
    summary: 'An online store for handcrafted leather bags and wallets, with collections, free personalisation and gifting.',
    tags: ['E-commerce', 'Custom website', 'Payments'],
    visual: 'shop',
    image: '/images/work/foldx-co-in.webp',
    url: 'https://foldx.co.in'
  }
];

// TODO: add team members ({ name, role, photo, linkedin }). The Team section stays hidden while empty.
export const team = [];

// TODO: review answers so they match how Fedigma actually works.
export const faqs = [
  {
    question: 'What does Fedigma do?',
    answer: 'Fedigma is the Fusion of Digital Management for education. We handle every digital need of an institute in one place: websites, apps, ERP, digital presence, marketing, digital classrooms, content, design and career counselling.'
  },
  {
    question: 'Do you only work with educational institutions?',
    answer: 'Education is our focus, but we also build custom websites for associations and businesses, including the GAIL Officers Association and FoldX.'
  },
  {
    question: 'How long does a website take?',
    answer: 'A typical institute website takes 2–4 weeks from approved design to launch. Larger portals and apps are planned in milestones.'
  },
  {
    question: 'Can you manage our social media and Google listing every month?',
    answer: 'Yes. Our digital presence plans cover posting, Google Business Profile, reviews and reporting, so your institute stays active and visible all year.'
  },
  {
    question: 'Will we own our website and content?',
    answer: 'Yes. Once the project is paid for, you own the website, designs and content, and we hand over all access.'
  },
  {
    question: 'Do you work with institutes outside Delhi?',
    answer: 'Yes. We work with institutes across India over calls, WhatsApp and video meetings, and visit on-site where needed.'
  }
];
